module.exports = __webpack_public_path__ + "img/QSL.807d55cc.png";